import { AutocompleteV2, Box } from '@cast/design-system';
import { PropsWithChildren } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import * as Sentry from '@sentry/react';

export const SidebarSectionErrorBoundary = ({
  children,
}: PropsWithChildren) => {
  return (
    <ErrorBoundary
      onError={(error) => {
        Sentry.captureException(error);
      }}
      FallbackComponent={({ resetErrorBoundary }) => (
        <Box onClick={resetErrorBoundary}>
          <AutocompleteV2
            items={['']}
            disabled
            placeholder="Error loading items"
          />
        </Box>
      )}
    >
      {children}
    </ErrorBoundary>
  );
};
